<template>
  <!-- <el-scrollbar wrapClass="scrollbar-wrapper"> -->
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
    >
      <sidebar-item :routes="permission_routers"></sidebar-item>
    </el-menu>
  <!-- </el-scrollbar> -->
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    branchLeave() {
      this.$store.dispatch('SetBranchSelected', null ).then(() => {
        this.$store.dispatch('ClearRoutes').then(() => {
          this.$router.push('/')
        })
      })
    }
  }
  // beforeRouteLeave(to, from, next) {
  //   console.log("test")
  //   next()
  //   window.reload()
  // }
}
</script>
<style lang="scss">
  .scrollbar-wrapper {
    //margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/layout/components/Sidebar/index.vue